/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from "react-redux";
import { Select, Modal, Table, Switch } from 'antd';
import { ModalHeader } from "datastake-daf/dist/components";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { MODAL_WIDTH } from "../config";
import { actions } from "../../../../store/reducers/authentication";
import Footer from "../../../../components/dashboards/components/project-visualisation/components/Footer";
import { useApplications } from "../../../../context/Applications";

function PermissionsModal({
  authentication: { user },
  getRegistrationOptions,
  selectedUser = {},
  handleCancel = () => { },
  t = (s) => s,
  isLoading = false,
  onUsersSubmit = () => { },
}) {
  const isActivate = useMemo(() => selectedUser.modalView === 'blocked', []);
  const { applications } = useApplications();

  const [hasChanges, setHasChanges] = useState(isActivate);
  const [data, setData] = useState(isActivate ?
    (selectedUser?.apps || []).map((app, i) => {
      const _app = applications.find((a) => a.app === app.app);
      return {
        ..._app,
        ...app,
        key: i,
      };
    }) : applications.map((c, i) => ({
      ...c,
      key: i,
      access: selectedUser?.apps?.find((a) => a.app === c.app)?.access,
      interface: selectedUser?.apps?.find((a) => a.app === c.app)?.interface,
    })));

  const changeAppData = useCallback((appKey, val) => {
    setHasChanges(true);

    setData((p) => p.map((app) => {
      if (app.app === appKey) {
        return { ...app, ...val };
      }

      return app;
    }));
  }, []);

  const dataSource = useMemo(() => {
    const emptyDataSource = [];

    for (let i = 0; i < 10; i++) {
      emptyDataSource.push({ id: i, empty: true, key: i });
    }

    return emptyDataSource.map((empty, i) => data[i] || empty);
  }, [data]);

  useEffect(() => {
    getRegistrationOptions({ language: user.language });
  }, [user.language])

  const onSubmit = () => {
    onUsersSubmit(data.map((d) => ({
      access: d.access,
      app: d.app,
      interface: d.interface,
    })));
  };

  const columns = useMemo(() => [
    {
      title: t('Applications'),
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
    },
    {
      title: t('Access'),
      dataIndex: 'access',
      key: 'access',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return (
          <div className="daf-default-cell">
            <Switch
              size="small"
              checked={val}
              onChange={(checked) => {
                changeAppData(all.app, { access: checked });
              }}
            />
          </div>
        )
      }
    },
    {
      title: t('Interfaces'),
      dataIndex: 'interface',
      key: 'interface',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return (
          <div className="daf-default-cell">
            <Select
              value={val}
              size="small"
              disabled={!all.access}
              style={{ width: 150 }}
              onChange={(val) => {
                changeAppData(all.app, { interface: val });
              }}
            >
              {(all.interfaces || []).map((i) => (
                <Select.Option key={i.value} value={i.value}>
                  {i.label}
                </Select.Option>
              ))}
            </Select>
          </div>
        );
      }
    },
  ], [t, changeAppData]);

  return (
    <Modal
      centered
      wrapClassName="bordered-footer no-p-body-mobile"
      title={(
        <ModalHeader
          title={t(isActivate ? 'Activate' : 'Edit Account Permissions')}
        />
      )}
      footer={[
        <Footer
          t={t}
          key="footer"
          className="mt-0"
          onSubmit={onSubmit}
          onClose={handleCancel}
          disabledFooter={!hasChanges}
        />
      ]}
      open={selectedUser}
      onCancel={handleCancel}
      width={MODAL_WIDTH}
    >
      <div className="daf-table-wrapper flex-1 flex-c extra-small small-body no-pagination">
        <Table
          renderWrapper={false}
          size="small"
          columns={columns}
          scroll={{ x: 500 }}
          loading={isLoading}
          rowKey="key"
          dataSource={dataSource}
          doEmptyRows
        />
      </div>
    </Modal>
  )
}

const mstp = ({ authentication }) => ({ authentication });

export default connect(mstp, actions)(PermissionsModal);
